<div class="bubble">
  <mat-icon>{{icon}}</mat-icon>
  {{text}}
  <span class="badge" *ngIf="badgeText">{{ badgeText }}</span>
</div>
